import type { AiLabsPartner } from '../types'

// Partners in display order; logos mapped by id in AiLabsPartners.
export const AI_LABS_PARTNERS: AiLabsPartner[] = [
  { id: 'clay', name: 'Clay' },
  { id: 'decagon', name: 'Decagon' },
  { id: 'elevenlabs', name: 'ElevenLabs' },
  { id: 'gamma', name: 'Gamma' },
  { id: 'graphite', name: 'Graphite' },
  { id: 'openai', name: 'OpenAI' },
  { id: 'weightsAndBiases', name: 'W&B' },
  { id: 'micro1', name: 'micro1' },
]
